<template>
<m-pageframe
    title="Widget Analytics"
>
<v-container>

    <m-edit-date-range
        ref="date-bar"
        :value="date_range"
        v-on:input="onSetDateRange($event)"
        :menu_items="table_menu_items"
        v-on:export-excel="onExportExcel"
        v-on:refresh="onClickRefresh"
    />

    <v-data-table
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"

        hide-default-footer
    >
        <template v-slot:item.pct_opened="{ item }">
            {{item.pct_opened}}%
        </template>

        <template v-slot:item.pct_submitted="{ item }">
            {{item.pct_submitted}}%
        </template>

        <template v-slot:item.pct_abandoned_after_opening="{ item }">
            {{item.pct_abandoned_after_opening}}%
        </template>

     </v-data-table>

    <br/>
   Last cache flush time: {{pretty_last_flush_time}} 

</v-container>
</m-pageframe>
</template>

<script>

const Time = require('@/js/time.js');

export default 
{
    data() {
        return {
            date_range: null,
            last_flush_time: null,

            table_menu_items: [
                { 'text' : 'Refresh', 'event' : 'refresh' },
                { 'text' : 'Export to excel...', 'event' : 'export-excel' },
            ],

            headers: [
                { text: 'Date', value: 'az_date' },
                { text: 'Organization', value: 'organization_label' },
                { text: 'Domain', value: 'domain' },
                { text: 'Variation', value: 'variation_label' },
                { text: 'Shown', value: 'count_shown' },
                { text: 'Open', value: 'count_opened' },
                { text: 'Submitted', value: 'count_submitted' },
                { text: 'Abandoned', value: 'count_abandoned_after_opening' },
                { text: 'Open %', value: 'pct_opened' },
                { text: 'Submitted %', value: 'pct_submitted' },
                { text: 'Abandoned %', value: 'pct_abandoned_after_opening' }
            ],

            results: [],
        }
    },

    methods: {

        getSearch()
        {
            let search = {
                az_date: { 'type' : 'in-range-inclusive', 'values': [this.date_range.start, this.date_range.stop] },
            };

            return search;
        },

        search()
        {
            this.$rc.showSpinner();
            
            this.$rc.searchWidgetAnalytics(
                this.getSearch(),
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.last_flush_time = data.last_flush_time;

                    this.results  = data.results;

                    for ( let i = 0; i < this.results.length; i++ )
                    {
                        let result = this.results[i];

                        this.results[i].pct_opened = (result.count_opened / result.count_shown * 100).toFixed(1);
                        this.results[i].pct_submitted = (result.count_submitted / result.count_opened * 100).toFixed(1);
                        this.results[i].pct_abandoned_after_opening = (result.count_abandoned_after_opening / result.count_opened * 100).toFixed(1);

                        if ( isNaN(this.results[i].pct_opened) ) this.results[i].pct_opened = (0).toFixed(1);
                        if ( isNaN(this.results[i].pct_submitted) ) this.results[i].pct_submitted = (0).toFixed(1);
                        if ( isNaN(this.results[i].pct_abandoned_after_opening) ) this.results[i].pct_abandoned_after_opening = (0).toFixed(1);
                    }
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete search');
                },
            );
        },

        onSetDateRange(range)
        {
            this.date_range = range;
            this.search();
        },

        onExportExcel()
        {
            this.$rc.excelExport(
                    'EXPORT: /api/v1/widget/analytics/excel-export',
                    this.getSearch()
                );
        },

        onClickRefresh()
        {
            this.$rc.showSpinner();
            
            this.$rc.flushWidgetAnalytics(
                (data) => {
                    this.$rc.hideSpinner();

                    this.$rc.snackbar('Cache flushed and results refreshed');
                    this.search();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        }
    },

    computed: {
        pretty_last_flush_time() {
             if ( this.last_flush_time == null )
                return 'cache has never been flushed';
            
            return Time.getHumanReadableAge(this.last_flush_time);
        }
    },
}
</script>

<style lang="scss" scoped>
</style>